import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActionSuggestion } from '@panaya/ai-chat/shared';

@Injectable({
    providedIn: 'root'
})
export class AiChatActionsSuggestionsService {
    private readonly translateService = inject(TranslateService);

    private readonly suggestionIcons = new Map<string, string>([
        ['KEEP_CHANGES', 'check'],
        ['UNDO_CHANGES', 'undo']
    ]);

    public getProcessedSuggestions(suggestionKeys: string[] = []): ActionSuggestion[] {
        return suggestionKeys.map((suggestionKey) => this.createSuggestion(suggestionKey));
    }

    private createSuggestion(suggestionKey: string): ActionSuggestion {
        const icon = this.suggestionIcons.get(suggestionKey);
        const label = this.translateSuggestionKey(suggestionKey);
        return { label, icon };
    }

    private translateSuggestionKey(key: string): string {
        const translationKey = `aichat.actions.${key.toLowerCase()}`;
        return this.translateService.instant(translationKey);
    }
}
